import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography } from '@material-ui/core';
import gradients from 'utils/gradients';
import { format_number } from "../../../Utils";
import { root_string } from 'config.json';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#22303C',
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  details: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  avatar: {
    backgroundImage: gradients.green,
    height: 48,
    width: 48
  }
}));


const SellVolumes = props => {
  const [data, setData] = useState({
    sellVolumes: 0
  });

  useEffect(() => {
    (async () => {
      const res = await axios
        .get(root_string + '/api/data_api/V2_integrations')
        .catch(err => {
          console.log('Error from Ribbon API');
        });
      setData(
        {
          sellVolumes: res.data['data']['Ribbon']['sell_volumes']
        }
      );
    })();
  }, []);


  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div>
        <Typography
          component='h3'
          gutterBottom
          variant='overline'
        >
          Ribbon Sell Volumes
        </Typography>
        <div className={classes.details}>
          <Typography variant='h3' className='heading-number'>
            ${ format_number(data.sellVolumes) }
          </Typography>
        </div>
      </div>
    </Card>
  );
};

SellVolumes.propTypes = {
  className: PropTypes.string
};

export default SellVolumes;
